function toNumber(value) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
}

export function formatCurrency(value, isAr = true) {
    const amount = toNumber(value);
    const minimumFractionDigits = Number.isInteger(amount) ? 0 : 2;

    return `${new Intl.NumberFormat(isAr ? 'ar-SY' : 'en-US', {
        minimumFractionDigits,
        maximumFractionDigits: 2,
    }).format(amount)} ${isAr ? 'ل.س' : 'SYP'}`;
}
